import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes"; 
import { SabeeAppBookingListResponseProps } from "../../common/types/SabeeAppProps";


export const getBookingList = createAsyncThunk(
    "/bookingList/get",
    async (params:any, { rejectWithValue }) => {
        try { 
            const { data, errorMessage, isSuccess } = await commonNetwork.get("/sabeeapp/booking-list", params);
        
            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(errorMessage);
            }
        } catch (e: any) {
            return rejectWithValue(e.data.message);
        }
    }
);

 
export interface sabeeappBookingListtateType extends FetchResultType {
    bookingResult: SabeeAppBookingListResponseProps
}
export const sabeeappBookingListSlice = createSlice({
    name: "sabeeappBookingList",
    initialState: {
        bookingResult: {},
        isfirmAvailable: true,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
    },
    reducers: {
        clearState: (state) => {
            state.bookingResult = {};
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getBookingList.fulfilled, (state, { payload }) => {
            state.bookingResult = payload;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            return state;
        });
        builder.addCase(getBookingList.rejected, (state, { payload }:any) => {
     
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload;
        });
        builder.addCase(getBookingList.pending, (state) => {
            state.isFetching = true;
        });
    },
});
export const { clearState } = sabeeappBookingListSlice.actions;

export const sabeeappBookingListSelector = (state: any) => state.sabeeappBookingList;

export const sabeeappBookingListReducer = sabeeappBookingListSlice.reducer;
